import CommonService from '../../services/commonService';
import KuposCheckbox from './KuposCheckbox';
import KuposRadio from '../common/KuposRadio';
import React from 'react';
import { connect } from 'react-redux';
import getIcons from '../themes/functions/getIcons/getIcons';
import { withTranslation } from 'react-i18next';

const OperatorPay = props => {
	let balances = props && props.loginData ? props.loginData.balances : null;
	let kupos_pay_cards =
		props && props.loginData && props.loginData && props.loginData.kupos_pay_cards
			? props.loginData.kupos_pay_cards
			: [];
	const wallet_data = {
		wallets: {
			clp: {
				total: balances && balances['clp'].total,
				money: balances && balances['clp'].money,
				credit: balances && balances['clp'].credit,
			},
		},
	};

	// const paymentGateways = wallet_data.pg_details.payment_gateways;
	const paymentGateways = props.loginData && props.loginData.payment_gateways;
	const cardDetails = kupos_pay_cards;
	console.log('OperatorPay', props)

	const onChange = (selected, payment_mode, wallet_amount, virtual) => {
		props.onSelect(selected, payment_mode, wallet_amount, virtual);
	};

	const virtual_wallet = (props.operator && props.operator.is_virtual_wallet && props.showVirtualWallet)


	return (
		CommonService.isLoggedIn() &&
		props.operator && props.operator.is_pay_enabled && (
			<div
				style={{
					...styles.container,
					...(props.fare_amount === props.discount ? styles.disabled : {}),
				}}
			>


				<div>
					<div
						className="flex-row kupos-pay-check "
						onClick={() => { onChange('39:3', 3, wallet_data.wallets.clp.money, props.virtualChecked) }}
						style={{ marginBottom: 8, alignItems: 'center' }}
					>
						<KuposCheckbox
							circular
							checked={'39:3' == props.selected && !props.cardChecked}
							label={!virtual_wallet && CommonService.currency(wallet_data.wallets.clp.money).split(",")[0]}
							// showLogo={getIcons('operatorPay', props.operator)}
							showLogo={props.operator && props.operator.wallet_logo}
						// onChange={() => { onChange('39:3', 3, wallet_data.wallets.clp.money) }}
						/>
					</div>


					{virtual_wallet &&
						<div className="kupospay-and-creditos">
							<div className="inner-pay-method">
								<KuposCheckbox
									checked={'39:3' == props.selected && !props.cardChecked}
									onChange={() => { onChange('39:3', 3, wallet_data.wallets.clp.money, props.virtualChecked) }}
									label={CommonService.getOperatorPaymentLabel(props.operator)}
									labelStyle={{ fontSize: 13, color: "#000", marginRight: 10 }}
									labelBold={true}
								/>
								<span className="kupos-amount  font9"
									//  secondary-text
									style={{ marginTop: 3 }}

								>
									{CommonService.currency(wallet_data.wallets.clp.money).split(",")[0]}
								</span>
							</div>
							{/* {hideKuposCredits ? null : ( */}
							<div className="inner-pay-method">
								<KuposCheckbox
									checked={props.virtualChecked}
									onChange={() => props.onSelectCreditos()}
									label={CommonService.getOperatorCredtiosLabel(props.operator)}
									labelStyle={{ fontSize: 13, color: "#000" }}
									labelBold={true}
								/>
								<span className="kupos-amount font9"
									//  secondary-text
									style={{ marginTop: 3 }}
								>
									{CommonService.currency(wallet_data.wallets.clp.credit).split(",")[0]}
								</span>
							</div>

							{/* )} */}
						</div>
					}



				</div>




				{/* {paymentGateways && cardDetails.length === 0
        ? paymentGateways.map(pg => {
            switch (pg.pay_gay_type) {
              case 34:
                return (
                  <KuposRadio
                    checked={'37:34' == props.selected && !props.cardChecked}
                    operator={props.operator}
                    label={`Webpay Oneclick`}
                    onChange={() => onChange('37:34', 34, wallet_data.wallets.clp.money)}
                  />
                );
              default:
                return false;
            }
          })
        : false} */}

				{cardDetails
					? cardDetails.map(card => {
						switch (card.card_category) {
							case 1:
								return (
									<KuposRadio
										checked={'40:2' == props.selected && !props.cardChecked}
										operator={props.operator}
										// label={card.card_number}
										onChange={() => onChange('40:2', 2, wallet_data.wallets.clp.money, false)}
										showLogo
										isCard
										cardDetails={card}
									/>
								);
								break;
							case 2:
								return (
									<KuposRadio
										checked={'41:2' == props.selected && !props.cardChecked}
										operator={props.operator}
										// label={card.card_number}
										onChange={() => onChange('41:2', 2, wallet_data.wallets.clp.money, false)}
										showLogo
										isCard
										cardDetails={card}
									/>
								);
							default:
								return false;
						}
					})
					: false}
			</div>
		)
	);
};

OperatorPay.propTypes = {};

const styles = {
	container: {
		display: 'flex',
		gap: '50px',
		marginTop: '20px',
	},
	disabled: {
		opacity: 0.5,
		pointerEvents: 'none',
		cursor: 'not-allowed',
	},
};

/* istanbul ignore next */
function mapStateToProps(state) {
	return {
		loginData: state.common.loginData,
	};
}

export default connect(mapStateToProps)(withTranslation('common')(OperatorPay));



// WEBPACK FOOTER //
// ./src/features/common/OperatorPay.js